import { setContext } from '@apollo/client/link/context';

const isServer = !globalThis.document;

function getClientIp() {
  if (isServer) return '';
  const match = document.cookie.match(/(?:^|;\s*)client-ip=([^;]*)/);
  if (match) return decodeURIComponent(match[1]);
  const storageKey = `${process.env.NEXT_PUBLIC_STORE_VIEW_CODE}-user-ip`;
  return sessionStorage.getItem(storageKey) || '';
}

export default function createStoreLink() {
  return setContext((_, { headers }) => {
    const clientIp = getClientIp();

    return {
      headers: {
        ...headers,
        store: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
        'Content-Currency': process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
        ...(clientIp && { 'X-Client-IP': clientIp }),
      },
    };
  });
}
